import Header from "../HomeScreenHeader/HomeHeader/Header";
import React, { useState } from "react";
import { Splitter, SplitterPanel } from "primereact/splitter";
import "./UserToChannel.css";
import Master from "../AdminScreenDetail/Master";
import UserToAccountGroup from "../AdminScreenDetail/UserToAccountGroup";

export default function AccountGroupMap() {
  const [newUserId, setNewUserId] = useState();
  const [newUserName, setNewUserName] = useState();

  function onClickCheck(value) {
    if (value !== undefined) {
      const newUserId = value.UserID;
      const username = value.Username;
      setNewUserId(newUserId);
      setNewUserName(username);
    }
  }

  return (
    <div>
      {/* <Header /> */}
      <Splitter style={{ height: "100%" }}>
        <SplitterPanel
          size={70}
          minSize={45}
          className="flex align-items-center justify-content-center"
        >
          <Master onClickCheck={onClickCheck} />
        </SplitterPanel>
        <SplitterPanel
          size={30}
          minSize={30}
          className="flex align-items-center justify-content-center"
        >
          <UserToAccountGroup newUserId={newUserId} newUserName={newUserName} />
        </SplitterPanel>
      </Splitter>
    </div>
  );
}
